import type { CustomerDocument } from '@/types/customer-document';

/**
 * Mock customer documents data for demo mode.
 *
 * NOTE: this object is mutated in place by the demo upload/delete helpers in
 * useCustomerDocuments (documents are added/removed per customer id), so demo
 * sessions rely on this module-level reference persisting. Do not clone it.
 */
export const mockDocuments: Record<string, CustomerDocument[]> = {
  '1': [
    {
      id: 'doc-1',
      customerId: '1',
      fileName: 'Credit_Application_2023.pdf',
      fileType: 'application/pdf',
      fileSize: 245678,
      fileUrl: '#',
      uploadDate: '2024-01-15T10:30:00Z',
      uploadedBy: '1',
      uploadedByName: 'Sarah Johnson',
      description: 'Initial credit application form',
      category: 'credit_application',
    },
    {
      id: 'doc-2',
      customerId: '1',
      fileName: 'Service_Contract_2024.docx',
      fileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      fileSize: 156789,
      fileUrl: '#',
      uploadDate: '2024-02-20T14:45:00Z',
      uploadedBy: '2',
      uploadedByName: 'Michael Chen',
      description: 'Annual service agreement',
      category: 'contract',
    },
    {
      id: 'doc-3',
      customerId: '1',
      fileName: 'Payment_Terms_Agreement.pdf',
      fileType: 'application/pdf',
      fileSize: 98765,
      fileUrl: '#',
      uploadDate: '2024-03-10T09:15:00Z',
      uploadedBy: '1',
      uploadedByName: 'Sarah Johnson',
      description: 'Updated payment terms',
      category: 'contract',
    },
    {
      id: 'doc-4',
      customerId: '1',
      fileName: 'Account_Statement_Q1.xlsx',
      fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      fileSize: 234567,
      fileUrl: '#',
      uploadDate: '2024-04-05T16:20:00Z',
      uploadedBy: '3',
      uploadedByName: 'Emily Rodriguez',
      description: 'Q1 2024 account statement',
      category: 'statement',
    },
    {
      id: 'doc-5',
      customerId: '1',
      fileName: 'Correspondence_March_2024.pdf',
      fileType: 'application/pdf',
      fileSize: 123456,
      fileUrl: '#',
      uploadDate: '2024-03-28T11:30:00Z',
      uploadedBy: '1',
      uploadedByName: 'Sarah Johnson',
      description: 'Email correspondence regarding payment delay',
      category: 'correspondence',
    },
  ],
};
